import { render, staticRenderFns } from "./shopheaderMobile.vue?vue&type=template&id=501e39b9&"
import script from "./shopheaderMobile.vue?vue&type=script&lang=js&"
export * from "./shopheaderMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports